const ADMIRAL_QUESTION_ID_TO_AUTOFILL_TYPE = {
  primary_address_postalcode: 'section-parent postal-code',
  postcode: 'section-parent postal-code',
  email1: 'section-parent email',
  first_name: 'section-parent name',
  your_first_name: 'section-parent name',
  company_name: 'section-parent organization',
  phone_work: 'section-parent tel',
  phone_mobile: 'section-parent tel',
  mobile_number: 'section-parent tel',
  phone_home: 'section-parent tel',
  phone_office: 'section-parent tel',
  last_name: 'section-parent family-name',
  salutation: 'section-parent honorific-prefix',
  primary_address_street: 'section-parent street-address',
  primary_address_state: 'section-parent address-level1',
  primary_address_city: 'section-parent address-level2',
  country: 'section-parent country',
};

export default ADMIRAL_QUESTION_ID_TO_AUTOFILL_TYPE;
